module.exports = __webpack_public_path__ + "static/media/Shower Guy.d92119d1.jpg";